export enum ShippingMethodPropertyCode {
  InPostGeowidget = 'INPOST_GEOWIDGET',
}
